<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>location_city</mat-icon></div>
          <mat-card-title>Bairro <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span></mat-card-title>
        </div>
        <p *ngIf="carregando">Carregando...</p>
        <form *ngIf="formulario && !carregando" [formGroup]="formulario" (ngSubmit)="submit()">
          <div class="row">
            <div class="col-2"><mat-form-field class="full-width" appearance="fill"><mat-label>ID</mat-label><input formControlName="id" matInput readonly></mat-form-field></div>
            <div class="col-10"><mat-form-field class="full-width" appearance="fill"><mat-label>Nome</mat-label><input formControlName="name" matInput required minlength="3" maxlength="250"></mat-form-field></div>
          </div>
          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()"><mat-icon>arrow_back</mat-icon> Voltar</button>
            <button type="button" mat-stroked-button (click)="limpar()"><mat-icon>clear</mat-icon> Limpar</button>
            <button type="submit" mat-raised-button color="primary" [disabled]="formulario.invalid"><mat-icon>save</mat-icon> Salvar</button>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
</main>
